export default __webpack_public_path__ + "static/icon-clinical-peach-d83e2fc258a813f88987090e5019a8b2.png";